import { render, staticRenderFns } from "./DetailsFrame.vue?vue&type=template&id=210693c5&scoped=true&"
import script from "./DetailsFrame.vue?vue&type=script&lang=js&"
export * from "./DetailsFrame.vue?vue&type=script&lang=js&"
import style0 from "./DetailsFrame.vue?vue&type=style&index=0&id=210693c5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "210693c5",
  null
  
)

export default component.exports